import { FC, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { TFolder, useFolder } from '@modules/items';
import { StatusLabel } from '@shared/components';

import { TAllSubmissionsData } from '../types/submissions.types';
import AllSubmissionsContent from '../components/all/AllSubmissionsContent';
import { useSubmissions } from '../api';
import { useDocumentTitle } from '@shared/hooks';

const AllSubmissions: FC = () => {
  const { productId } = useParams();

  const { error: folderError, data: product } = useFolder(productId);
  const { error: submissionsError, data: submissions } = useSubmissions(productId as string);

  const error = folderError || submissionsError;

  const data: TAllSubmissionsData | null = useMemo(() => {
    if (product && submissions) {
      return {
        product: product as TFolder,
        submissions,
      };
    }
    return null;
  }, [product, submissions]);

  useDocumentTitle('Submissions');

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading submissions..."
      error={error}
      errorMessage="Loading submissions failed!"
      render={(resolvedData) => (
        <AllSubmissionsContent product={resolvedData.product} submissions={resolvedData.submissions} />
      )}
    />
  );
};

export default AllSubmissions;
